(function ($)
{
	window.LineTrackingTool = function () { };
	LineTrackingTool.prototype = new MouseTrackingTool();
	LineTrackingTool.prototype.TOOL_ID = "PricelineTrackingTool";
	LineTrackingTool.prototype.CurrentXPosition = 0;
	LineTrackingTool.prototype.Init = function (oChart) {
		this._baseInit(oChart);
		this._applyEvents();
		this._setTrackers();	
	};
	LineTrackingTool.prototype.Y_KEYS_BY_OVERLAY = {
		PriceChannel:["PriceChannelLowerY", "PriceChannelUpperY"],
		PSAR:["PSARY"],
		Price: ["CloseY"],
		PriceComparison:["CloseY"],
		TimeSeriesForecast:["TimeSeriesForecastY"],
		LinearRegression: [],
		WMA:["WMAY"],
		EMA:["EMAY"],
		MovingAverageEnvelope:["MovingAverageEnvelopeHighY", "MovingAverageEnvelopeLowY"],
		BollingerBands: ["BollingerLowerY", "BollingerUpperY", "BollingerSMAY"],
		BollingerBandsSMA:["BollingerSMAY"],
		SMA:["SMAY"],
		DMI:["DMI.ADXY"],
		"DMI.+":["DMI.+Y"],
		"DMI.-":["DMI.-Y"],
		"Mass Index":["MassIndexY"],
		MoneyFlowIndex:["MoneyFlowIndexY"],
		OnBalanceVolume:["OnBalanceVolumeY"],
		AccumulationDistribution:["AccumulationDistributionY"],
		ChaikinsVolatility:["ChaikinsVolatilityY"],
		MACD:["MACDY"],
		"Signal Line":["EMAY"],
		Divergence:["DivergenceY"],
		RSI:["RSIY"],
		UltimateOscillator:["UltimateOscillatorY"],
		WilliamsPercentR: ["WilliamsPercentRY"],
		RollingDividend: ["DividendY"],
		"FastStochastics_%D": ["DY"],
		"FastStochastics_%K": ["KY"],
		"SlowStochastics_%D": ["DY"],
		"SlowStochastics_%K": ["KY"],
		Momentum:["MomentumY"],
		Volume:["VolumeY"],
		PriceRateOfChange: ["RateOfChangeY"]
	};
	LineTrackingTool.prototype.OVERLAYS_ALLOW_MULTIPLE = {
		BollingerBands:true,
		BollingerBandsSMA:true,
		SMA:true,
		EMA:true,
		WMA:true
	};
	LineTrackingTool.prototype.USE_LABEL_FOR_TYPE = {
		DMI:true,
		MassIndex:true,
		MACD:true,
		FastStochastics:true
	}
	//Overrides
	LineTrackingTool.prototype.Enable = function () {
		this._enabled = true;
		this._startTracking();
		if (this._tracker) {
			this._tracker.removeClass("disabled");
		}
	};
	//Display
	LineTrackingTool.prototype._setTrackers = function () {
		var rLabelData = this._getLabelOutputData();
		this._trackersByType = {};
		this._trackers = $();

		var jPanels = this._getPanelElements();
		var oData = this._chart.GetOutputData() || {};
		var rPanelData = oData.Panels || [];
		for (var i = 0; i < rPanelData.length; i++) {
			if (!rPanelData[i].IsValid) { continue; }
			this._setPanelTrackers(rPanelData[i], $(jPanels[i]), i);
		}
		//this._setInitialTrackerCoords();
		this._handleMouseMove();
	};
	LineTrackingTool.prototype._processIndicatorType = function (sType, sLabel) {
		if (sType == "BollingerBands" && sLabel == "SMA") { sType = "BollingerBandsSMA"; }
		if (sLabel == "%K" || sLabel == "%D") {
			sType = sType + "_" + sLabel;
		}
		if (this.USE_LABEL_FOR_TYPE[sType]) {
			sType = sLabel;
		}
		return sType;
	};
	LineTrackingTool.prototype._setPanelTrackers = function (oPanel, jPanel, nPanel) {
		var rLabelData = this._getLabelOutputData(nPanel);
		if (!rLabelData) { return; }
		for (var i = 0; i < rLabelData.length; i++) {
			var oLabel = rLabelData[i];
			var sType = this._getPanelTypeByUid(oLabel.Uid, nPanel) || this._getOverlayTypeByUID(oLabel.Uid, nPanel) || "Price";
			sType = this._processIndicatorType(sType, oLabel.Label);
			var rKeys = this.Y_KEYS_BY_OVERLAY[sType];
			if (!rKeys) { continue; }
			for (var j = 0; j < rKeys.length; j++) {
				var jTracker = this._buildTracker(oLabel.Color, jPanel);
				var sKey = this._getKeyByType(sType, j, oLabel);

				this._trackersByType[sType + "-" + sKey + "-" + oLabel.Uid] = { Tracker: jTracker, Panel: nPanel, Key: sKey };
				this._trackers = this._trackers.add(jTracker);
			}
		}
	};
	LineTrackingTool.prototype._getKeyByType = function (sType, nIndex, oLabel) {
		var _sType = new String(sType);
		var sKey = null;
		if (_sType == "Price" && oLabel.Parameters != this._chart.GetIssueId()) {
			_sType = "PriceComparison";
		}
		var rKeys = this.Y_KEYS_BY_OVERLAY[_sType];
		if (rKeys) {
			sKey = rKeys[nIndex];
			if (this.OVERLAYS_ALLOW_MULTIPLE[_sType]) {
				sKey = sKey + oLabel.Uid;
			}
			if (_sType == "PriceComparison") {
				sKey = sKey + oLabel.Parameters;
			}
		}
		return sKey;
	};
	LineTrackingTool.prototype._buildTracker = function (sColor, jPanel) {
		var jTracker = $("<div class='tool-tracker'></div>")
			.css({"background-color": sColor});
		jPanel.append(jTracker);
		return jTracker;
	};
	//Event Application
	LineTrackingTool.prototype._applyEvents = function () {
		this._getPanelElements()
			.mouseover(this._handleMouseOver.eventContext(this));
	};
	//Event Handlers
	LineTrackingTool.prototype._handleMouseMove = function (oMouse) {
		var rData = [];
		var trackers = this._trackersByType;
		var hasMouseCoords = !!oMouse;
		var nMousePosX = hasMouseCoords ? oMouse.x - this._offsetX : null;
		var tracker, jTracker, nPanel, nTop, nCloseX, sType, oData, sKey, nValueX;
		for (sType in trackers) {
			if (!trackers.hasOwnProperty(sType)) { continue; }
			tracker = trackers[sType];
			jTracker = tracker.Tracker;
			nPanel = tracker.Panel;
			sKey = tracker.Key;
			if (!rData[nPanel]) {
				nValueX = hasMouseCoords ? nMousePosX : this._getLastDataPoint(nPanel);
				rData[nPanel] = this._getDataForLatestXCoord(nValueX, nPanel);
			}
			oData = rData[nPanel];
			if (!oData) { continue; }
			nTop = oData[sKey];
			if (nTop !== undefined) {
				nCloseX = oData.CloseX;
				jTracker
					.show()
					.css({ "left": nCloseX + "px", "top": nTop + "px" });
				this.CurrentXPosition = nCloseX;
			} else {
				jTracker.hide();
			}
		}
	};
	LineTrackingTool.prototype._handleMouseOver = function (oEvent, oEl) {
		this._offsetX = $(oEl).offset().left;
	};
	LineTrackingTool.prototype._handleOutputDataUpdate = function (oData) {
		this._startTracking();
		this._outputData = oData;
		if(this._trackers){ this._trackers.remove(); }
		this._setTrackers();
	};
	//Misc
	LineTrackingTool.prototype._getLabelOutputData = function (nPanel) {
		var oData = null;
		nPanel = nPanel || 0;
		this._outputData = this._outputData || this._chart.GetOutputData();
		if (this._outputData) {
			oData = this._outputData.Panels[nPanel].Labels;
		}
		return oData;
	};
})(jQuery);